var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPinFix48Filled = function SvgIconPinFix48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.606 10.624h3.008v4.58h.752v-4.58h3.008c.2 0 .376-.17.376-.363V9.26c0-.724-.575-1.342-1.305-1.428l-.221-1.853a.377.377 0 0 0-.376-.32H7.154c-.199 0-.354.128-.376.32L6.557 7.81c-.73.085-1.305.682-1.305 1.428v1.001c-.022.234.155.384.354.384ZM6.34 4.977h5.32c.216 0 .408-.202.408-.429v-.91c0-.757-.6-1.388-1.318-1.388h-3.5c-.719 0-1.318.631-1.318 1.389v.909c0 .253.192.43.407.43Z",
    fill: "current"
  })));
};
export default SvgIconPinFix48Filled;